import RadioBar from "../../../../components/RadioBar/component";
/**
 * This function handles creating a radio bar
 *
 * @returns {JSX} component structure for radio bar
 */
const RadioBarContainer = ({ params }) => {
    return (
        <div>
            <RadioBar
                listenLinkCMP={"Radio_mobileweb_unit"}
                defaultRadioRegion={params?.defaultRadioRegion}
            />
        </div>
    );
};

export default RadioBarContainer;
